import urlJoin from 'url-join';
import AppSettings from 'es/core/AppSettings';

export function fetchLoginUrl(returnUrl: string): string {
    if (!returnUrl) {
        return AppSettings.authUrl;
    }
    const encodedReturnUrl = encodeURIComponent(returnUrl);
    return urlJoin(AppSettings.authUrl, `?ReturnUrl=${encodedReturnUrl}`);
}

export default fetchLoginUrl;
